import React, { useEffect, useRef, useState } from "react";
import Menubar from "../Menubar/Menubar";
import { Outlet } from "react-router-dom";
import { IoMdClose } from "react-icons/io";
import { GrFormCheckmark } from "react-icons/gr";

const HotelBrochureElementor = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  // const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 1024);
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const savedState = localStorage.getItem("menubarOpen");

    if (savedState !== null) {
      return JSON.parse(savedState);
    }

    return window.innerWidth >= 1024;
  });

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
      if (mobile) setIsSidebarOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // count
  const [formData, setFormData] = useState({});
  const [activeField, setActiveField] = useState(null);

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // image upload
  const [images, setImages] = useState({});
  const fileInputRefs = useRef({});

  const handleImageUpload = (e, key) => {
    const file = e.target.files[0];

    if (file && file.type === "image/webp") {
      setImages((prev) => ({
        ...prev,
        [key]: URL.createObjectURL(file),
      }));
    } else {
      alert("Only .webp images are allowed");
    }
  };

  const openFilePicker = (key) => {
    if (fileInputRefs.current[key]) {
      fileInputRefs.current[key].click();
    }
  };

  // ===== Amenities Logic =====
  const [showPopup, setShowPopup] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedAmenities, setSelectedAmenities] = useState([]);
  const [tempSelected, setTempSelected] = useState([]);
  const [error, setError] = useState("");
  const [, setSearchActive] = useState(false);

  const page4Ref = useRef(null);

  const amenitiesList = [
    {
      name: "Entertainment Area",
      imgSrc:
        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/4bf1c038-d95f-4c27-8eab-79f359a5bc00/public",
    },
    {
      name: "Catering services",
      imgSrc:
        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/bb6704a9-44e9-4585-21a6-7abcd98cc300/public",
    },
    {
      name: "Bar",
      imgSrc:
        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/f62815e3-de4a-4a8b-ed8c-53540d691100/public",
    },
    {
      name: "Bathtub",
      imgSrc:
        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/1936fb51-8d47-4312-7d29-775ce395c400/public",
    },
    {
      name: "Bedroom",
      imgSrc:
        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/06e7dd94-ed3d-4b6e-15d4-f2217c3cf900/public",
    },
    {
      name: "Chef",
      imgSrc:
        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/3c80fd6c-6236-4c27-6907-f6a12a548e00/public",
    },
    {
      name: "Evening Turndown services",
      imgSrc:
        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/b7f24198-46a9-4d9d-5677-899fa62cf300/public",
    },
    {
      name: "GYM",
      imgSrc:
        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/d52c9441-5857-42da-a0c7-9029cd39ae00/public",
    },
    {
      name: "Game",
      imgSrc:
        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/a42d3f5f-4509-4d42-b654-234ca3cb4f00/public",
    },
    {
      name: "Gazebo",
      imgSrc:
        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/96201a25-4565-470c-ec62-287d2eaca000/public",
    },
    {
      name: "Jacuzzi",
      imgSrc:
        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/a278477b-7a08-454c-29dc-e83536a84000/public",
    },
    {
      name: "Garden",
      imgSrc:
        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/196104dc-f22e-4bc4-a0e7-54876564b200/public",
    },
    {
      name: "Kitchen",
      imgSrc:
        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/82b84600-29c2-4c6a-dba0-b693efa3ee00/public",
    },
    {
      name: "Power Backup",
      imgSrc:
        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/66c1654e-17e2-429a-ef3c-8edb9fbfbc00/public",
    },
    {
      name: "Property Manager",
      imgSrc:
        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/f3d9b4f4-5b09-4d81-7ab6-089ed2823300/public",
    },
    {
      name: "Loungers",
      imgSrc:
        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/e8063a6e-d84d-4aa0-d4ea-bb2235ba5400/public",
    },
    {
      name: "Pool",
      imgSrc:
        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/38baf459-b4a1-46a8-07b3-f44a552d5700/public",
    },
    {
      name: "Paddy Field View",
      imgSrc:
        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/4c09cb21-d73e-4936-f39b-962e088de800/public",
    },
    {
      name: "Toiletries",
      imgSrc:
        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/d931ddba-e976-439f-01c8-d09cb9a09500/public",
    },
    {
      name: "Scenic View",
      imgSrc:
        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/5e713758-7d3d-4060-33fb-721ad7532e00/public",
    },
    {
      name: "Wifi",
      imgSrc:
        "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/1a095f92-8093-44d6-8865-87528b883400/public",
    },
  ];

  const filteredAmenities = amenitiesList.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase()),
  );

  const handleSelect = (item) => {
    const exists = tempSelected.find((a) => a.name === item.name);

    if (exists) {
      setTempSelected(tempSelected.filter((a) => a.name !== item.name));
    } else if (tempSelected.length < 20) {
      setTempSelected([...tempSelected, item]);
    }
  };

  const handleOk = () => {
    if (tempSelected.length === 0) {
      setError("Select 1 amenity compulsory");
      return;
    }

    setSelectedAmenities(tempSelected);
    setShowPopup(false);
    setError("");
  };

  const chunkAmenities = (arr, size) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };

  const pages = chunkAmenities(selectedAmenities, 15);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        setTimeout(() => {
          setShowPopup(true);
        }, 2000);
      }
    });

    if (page4Ref.current) {
      observer.observe(page4Ref.current);
    }
  }, []);

  // close button
  const handleCancel = () => {
    setTempSelected(selectedAmenities);
    setShowPopup(false);
    setError("");
  };

  return (
    <div className="flex bg-[#F8F9FA]">
      <Menubar
        isOpen={isSidebarOpen}
        setIsOpen={setIsSidebarOpen}
        isMobile={isMobile}
      />

      <main
        className={`p-5 lg:p-6 transition-all duration-500 w-full ${
          isMobile ? "ml-0" : isSidebarOpen ? "ml-64" : "ml-16"
        }`}
      >
        <Outlet />

        {/* Header */}
        <div className="flex justify-between gap-5 items-start lg:items-center">
          <div className="flex flex-col lg:flex-row gap-5 items-center">
            <p className="font-semibold text-xl text-gray-700 ml-10 lg:ml-0">
              Hotel Brochure Elementor
            </p>
          </div>
          <div className="flex gap-2 items-center"></div>
        </div>

        <div className="my-5">
          <div className="min-h-screen flex flex-col items-center py-6 print:bg-[#FDFDFD] print:p-0">
            <style
              dangerouslySetInnerHTML={{
                __html: `
          @import url('https://fonts.googleapis.com/css2?family=Playfair+Display&family=Montserrat&display=swap');
          @page { size: A4; margin: 0; }
          body { margin: 0; padding: 0; }
          .a4-container { width: 210mm; height: 297mm; background: white; display: block; margin: 0 auto; box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1); }
          @media screen { .a4-container { transform: scale(0.98); transform-origin: top center; margin-bottom: 20px; } }
          @media print { .a4-container { transform: scale(1); page-break-after: always; break-after: page; margin: 0; box-shadow: none !important; } }
          .playfair { font-family: 'Playfair Display', serif; }
          .montserrat { font-family: 'Montserrat', sans-serif; }
        `,
              }}
            />
            {/* page 1 */}
            <div className="a4-container relative overflow-hidden print:shadow-none">
              <div className="relative h-full w-full flex flex-col items-center px-16 pt-24 pb-12">
                <div className="absolute top-0 left-12 flex gap-6 h-full">
                  <div className="h-[270px] border-l-2 border-gray-400"></div>
                  <div className="h-[200px] border-l-2 border-gray-400"></div>
                  <div className="h-[150px] border-l-2 border-gray-400"></div>
                </div>

                <div className="absolute top-6 right-6">
                  <img
                    src="https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/6ced36d8-b8ff-4f01-aaa8-c3b572f35a00/public" // Zorba_hotelBrochure_bg.webp
                    alt="Logo"
                    className="h-32"
                  />
                </div>

                <div className="mt-auto text-center">
                  <input
                    type="text"
                    placeholder="Hotel Name"
                    value={formData.Mansionhaus}
                    onChange={(e) =>
                      handleChange("Mansionhaus", e.target.value)
                    }
                    onFocus={() => setActiveField("Mansionhaus")}
                    onBlur={() => setActiveField(null)}
                    maxLength={20}
                    className="text-5xl playfair
                   bg-transparent border border-transparent text-center 
                  focus:border-black outline-none duration-300 focus:ring-0"
                  />

                  {activeField === "Mansionhaus" && (
                    <p className="text-xs text-gray-500 ">
                      {(formData.Mansionhaus || "").length}/20
                    </p>
                  )}
                  <input
                    type="text"
                    placeholder="ENTER Location..."
                    value={formData.Location || ""}
                    onChange={(e) => handleChange("Location", e.target.value)}
                    onFocus={() => setActiveField("Location")}
                    onBlur={() => setActiveField(null)}
                    maxLength={60}
                    className="montserrat tracking-[0.1em] text-sm font-medium mt-3 w-full py-2 pl-2 pr-4 uppercase text-center
                    bg-transparent border border-transparent duration-300
                    focus:border-black focus:ring-0 outline-none"
                  />

                  {activeField === "Location" && (
                    <p className="text-xs text-gray-500 text-center">
                      {(formData.Location || "").length}/60
                    </p>
                  )}
                </div>

                <div
                  className="flex justify-center mt-16 
                w-[600px] h-[600px] bg-transparent overflow-hidden cursor-pointer border-2 border-gray-300"
                >
                  {images.page1 ? (
                    <img
                      src={images.page1}
                      alt="Uploaded"
                      className="w-[600px] h-[600px] object-cover"
                    />
                  ) : (
                    <div
                      className="flex flex-col items-center justify-center h-full text-gray-500"
                      onClick={() => openFilePicker("page1")}
                    >
                      <svg
                        width="60"
                        height="60"
                        viewBox="0 0 24 24"
                        fill="none"
                        className="mb-2"
                      >
                        <rect
                          x="2"
                          y="4"
                          width="16"
                          height="13"
                          rx="2"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                        <path
                          d="M2 13L6 9L11 14L14 11L18 15"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle
                          cx="17"
                          cy="17"
                          r="6"
                          fill="white"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M17 14V20M14 17H20"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                      </svg>

                      <span>Add Only Webp img</span>
                    </div>
                  )}
                  <input
                    type="file"
                    accept="image/webp"
                    ref={(el) => (fileInputRefs.current["page1"] = el)}
                    onChange={(e) => handleImageUpload(e, "page1")}
                    className="hidden"
                  />
                </div>

                <div className="mt-6">
                  <a
                    href="https://zorbastays.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <p className="montserrat tracking-[0.2em] text-[11px]">
                      www.zorbastays.com
                    </p>
                  </a>
                </div>
              </div>
            </div>

            {/* page 2 */}
            <div className="a4-container relative overflow-hidden print:shadow-none">
              <div className="h-full w-full flex flex-col px-20 pt-20">
                <div
                  className="w-full flex justify-center mb-12 h-[500px]
                  border-2 border-gray-300 cursor-pointer overflow-hidden"
                  onClick={() => openFilePicker("page2")}
                >
                  {images.page2 ? (
                    <img
                      src={images.page2}
                      alt="Uploaded"
                      className="w-full h-[500px] object-cover"
                    />
                  ) : (
                    <div className="flex flex-col items-center justify-center h-full text-gray-500">
                      <svg
                        width="60"
                        height="60"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x="2"
                          y="4"
                          width="16"
                          height="13"
                          rx="2"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                        <path
                          d="M2 13L6 9L11 14L14 11L18 15"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle
                          cx="17"
                          cy="17"
                          r="6"
                          fill="white"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M17 14V20M14 17H20"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                      </svg>

                      <span className="mt-2">Add Only Webp img</span>
                    </div>
                  )}

                  <input
                    type="file"
                    accept="image/webp"
                    ref={(el) => (fileInputRefs.current["page2"] = el)}
                    onChange={(e) => handleImageUpload(e, "page2")}
                    className="hidden"
                  />
                </div>

                <div className="flex flex-col text-left max-w-2xl">
                  <input
                    type="text"
                    placeholder="The Mansion"
                    value={formData.Mansion}
                    onChange={(e) => handleChange("Mansion", e.target.value)}
                    onFocus={() => setActiveField("Mansion")}
                    onBlur={() => setActiveField(null)}
                    maxLength={30}
                    className="text-4xl playfair text-slate-800
                   bg-transparent border border-transparent 
                  focus:border-black outline-none duration-300 focus:ring-0"
                  />

                  {activeField === "Mansion" && (
                    <p className="text-xs text-gray-500 ">
                      {(formData.Mansion || "").length}/30
                    </p>
                  )}

                  <div className="montserrat mt-6 w-full text-gray-600 tracking-wide text-[15px] leading-relaxed space-y-4">
                    <div>
                      <textarea
                        placeholder="Start Writing..."
                        value={formData.MansionDesc1 || ""}
                        onChange={(e) =>
                          handleChange("MansionDesc1", e.target.value)
                        }
                        onFocus={() => setActiveField("MansionDesc1")}
                        onBlur={() => setActiveField(null)}
                        maxLength={400}
                        rows={6}
                        className="w-full bg-transparent resize-none p-2
                      border border-transparent outline-none
                      focus:border-black transition-all duration-300 focus:ring-0"
                      />

                      {activeField === "MansionDesc1" && (
                        <p className="text-xs text-gray-500 text-right">
                          {(formData.MansionDesc1 || "").length}/400
                        </p>
                      )}
                    </div>

                    <div>
                      <textarea
                        placeholder="Start Writing..."
                        value={formData.MansionDesc2 || ""}
                        onChange={(e) =>
                          handleChange("MansionDesc2", e.target.value)
                        }
                        onFocus={() => setActiveField("MansionDesc2")}
                        onBlur={() => setActiveField(null)}
                        maxLength={350}
                        rows={5}
                        className="w-full bg-transparent outline-none resize-none p-2
                        border border-transparent
                      focus:border-black focus:ring-0 transition-all duration-300"
                      />

                      {activeField === "MansionDesc2" && (
                        <p className="text-xs text-gray-500 text-right">
                          {(formData.MansionDesc2 || "").length}/350
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* page 3 */}
            <div className="a4-container relative overflow-hidden print:shadow-none">
              <div className="h-full w-full flex flex-col items-center px-12 py-16">
                <div className="grid grid-cols-2 gap-4 w-full h-[85%]">
                  <div
                    className="h-[450px] border-2 border-gray-300 cursor-pointer overflow-hidden"
                    onClick={() => openFilePicker("page3_img1")}
                  >
                    {images.page3_img1 && (
                      <img
                        alt="img"
                        src={images.page3_img1}
                        className="w-full h-full object-cover"
                      />
                    )}
                    <div className="flex flex-col items-center justify-center h-full text-gray-500">
                      <svg
                        width="60"
                        height="60"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x="2"
                          y="4"
                          width="16"
                          height="13"
                          rx="2"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                        <path
                          d="M2 13L6 9L11 14L14 11L18 15"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle
                          cx="17"
                          cy="17"
                          r="6"
                          fill="white"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M17 14V20M14 17H20"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                      </svg>

                      <span className="mt-2">Add Only Webp img</span>
                    </div>

                    <input
                      type="file"
                      accept="image/webp"
                      ref={(el) => (fileInputRefs.current["page3_img1"] = el)}
                      onChange={(e) => handleImageUpload(e, "page3_img1")}
                      className="hidden"
                    />
                  </div>

                  <div
                    className="h-[450px] border-2 border-gray-300 cursor-pointer overflow-hidden"
                    onClick={() => openFilePicker("page3_img2")}
                  >
                    {images.page3_img2 && (
                      <img
                        alt="img"
                        src={images.page3_img2}
                        className="w-full h-full object-cover"
                      />
                    )}
                    <div className="flex flex-col items-center justify-center h-full text-gray-500">
                      <svg
                        width="60"
                        height="60"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x="2"
                          y="4"
                          width="16"
                          height="13"
                          rx="2"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                        <path
                          d="M2 13L6 9L11 14L14 11L18 15"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle
                          cx="17"
                          cy="17"
                          r="6"
                          fill="white"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M17 14V20M14 17H20"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                      </svg>

                      <span className="mt-2">Add Only Webp img</span>
                    </div>

                    <input
                      type="file"
                      accept="image/webp"
                      ref={(el) => (fileInputRefs.current["page3_img2"] = el)}
                      onChange={(e) => handleImageUpload(e, "page3_img2")}
                      className="hidden"
                    />
                  </div>

                  <div
                    className="col-span-2 h-[350px] w-[450px] mt-2 border-2 border-gray-300 cursor-pointer overflow-hidden"
                    onClick={() => openFilePicker("page3_img3")}
                  >
                    {images.page3_img3 && (
                      <img
                        alt="img"
                        src={images.page3_img3}
                        className="w-full h-full object-cover"
                      />
                    )}
                    <div className="flex flex-col items-center justify-center h-full text-gray-500">
                      <svg
                        width="60"
                        height="60"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x="2"
                          y="4"
                          width="16"
                          height="13"
                          rx="2"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                        <path
                          d="M2 13L6 9L11 14L14 11L18 15"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle
                          cx="17"
                          cy="17"
                          r="6"
                          fill="white"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M17 14V20M14 17H20"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                      </svg>

                      <span className="mt-2">Add Only Webp img</span>
                    </div>

                    <input
                      type="file"
                      accept="image/webp"
                      ref={(el) => (fileInputRefs.current["page3_img3"] = el)}
                      onChange={(e) => handleImageUpload(e, "page3_img3")}
                      className="hidden"
                    />
                  </div>
                </div>

                <div className="mt-auto mb-0 flex items-center gap-4 w-full justify-center">
                  <div className="w-12 border-t-2 border-gray-400"></div>

                  <div className="w-9 h-9 rounded-full border border-gray-400 flex items-center justify-center">
                    <img
                      src="https://zorbastays.com/ZORBA_logo_iconGreen.webp"
                      alt="The Mansion"
                      className="w-8 h-5 brightness-0"
                    />
                  </div>

                  <div className="w-12 border-t-2 border-gray-400"></div>
                </div>
              </div>
            </div>

            {/* page 4 */}
            <>
              {pages.length === 0 ? (
                <div
                  ref={page4Ref}
                  className="a4-container bg-[#f8f7f6] p-16 flex flex-col justify-center items-center"
                >
                  <h2 className="text-4xl playfair mb-20">
                    Inclusions & Amenities
                  </h2>

                  <button
                    onClick={() => setShowPopup(true)}
                    className="border px-8 py-3 rounded-md"
                  >
                    + Add Amenities
                  </button>
                </div>
              ) : (
                pages.map((page, pageIndex) => (
                  <div
                    key={pageIndex}
                    className="a4-container bg-[#f8f7f6] p-16 cursor-pointer"
                    onClick={() => setShowPopup(true)}
                  >
                    {pageIndex === 0 && (
                      <h2 className="text-4xl playfair mb-10">
                        Inclusions & Amenities
                      </h2>
                    )}

                    <div className="grid grid-cols-3 gap-y-16 gap-x-12">
                      {page.map((item, index) => (
                        <div
                          key={index}
                          className="flex flex-col items-center text-center"
                        >
                          <div className="w-24 h-24 flex items-center justify-center">
                            <img
                              src={item.imgSrc}
                              alt={item.name}
                              className="w-24 h-24 object-contain"
                            />
                          </div>

                          <p className="montserrat text-sm tracking-[0.2em] font-medium leading-tight max-w-[140px]">
                            {item.name}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                ))
              )}
            </>
            {showPopup && (
              <div className="fixed inset-0 bg-black/40 flex justify-center items-start pt-20 z-50">
                <div className="bg-white max-w-5xl rounded-xl p-6 relative">
                  {selectedAmenities.length > 0 && (
                    <button
                      onClick={handleCancel}
                      className="absolute top-4 right-4 text-gray-400 hover:text-black"
                    >
                      <IoMdClose size={20} />
                    </button>
                  )}

                  <h2 className="text-2xl text-center font-semibold">
                    Amenities
                  </h2>
                  <p className="text-center text-gray-500 mb-2">
                    {tempSelected.length} selected
                  </p>

                  <input
                    type="text"
                    placeholder="Search amenities..."
                    value={search}
                    onFocus={() => setSearchActive(true)}
                    onChange={(e) => setSearch(e.target.value)}
                    className="w-full border rounded-lg px-4 py-3 mb-4 focus:border-black outline-none duration-300 focus:ring-0"
                  />

                  {error && (
                    <p className="text-red-500 text-sm text-center mb-3">
                      {error}
                    </p>
                  )}

                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-h-[350px] overflow-y-auto overflow-hidden">
                    {filteredAmenities.map((item, index) => {
                      const isSelected = tempSelected.find(
                        (a) => a.name === item.name,
                      );
                      return (
                        <div
                          key={index}
                          onClick={() => handleSelect(item)}
                          className={`relative p-2 border rounded-lg cursor-pointer flex flex-col items-center w-40 h-40
                          ${isSelected ? "border-black bg-gray-100" : "border-gray-200"}`}
                        >
                          <div className="absolute top-2 right-2">
                            <div
                              className={`w-4 h-4 rounded-full flex items-center justify-center border
                              ${isSelected ? "bg-black border-black" : "border-gray-400 bg-white"}`}
                            >
                              {isSelected && (
                                <GrFormCheckmark className="text-white" />
                              )}
                            </div>
                          </div>
                          <div className="w-24 h-24 flex items-center justify-center">
                            <img
                              src={item.imgSrc}
                              alt={item.name}
                              className="max-w-full max-h-full object-contain"
                            />
                          </div>
                          <p className="text-xs mt-3 text-center tracking-wide">
                            {item.name}
                          </p>
                        </div>
                      );
                    })}
                  </div>

                  <div className="flex justify-end mt-6 space-x-3">
                    <button
                      onClick={handleOk}
                      className="bg-black text-white px-6 py-2 rounded-lg hover:bg-gray-800"
                    >
                      OK
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* page 5 */}
            <div className="a4-container relative overflow-hidden bg-white print:shadow-none">
              <div className="flex h-full w-full flex-col p-16">
                <div className="mb-2 flex justify-end">
                  <div className="w-full">
                    <input
                      type="text"
                      placeholder="LIVING AREA"
                      value={formData.LIVING || ""}
                      onChange={(e) => handleChange("LIVING", e.target.value)}
                      onFocus={() => setActiveField("LIVING")}
                      onBlur={() => setActiveField(null)}
                      maxLength={60}
                      className="montserrat text-[10px] font-semibold uppercase tracking-[0.3em]
                    w-full py-2 pl-2 pr-4 text-right
                    bg-transparent border border-transparent duration-300
                    focus:border-black focus:ring-0 outline-none"
                    />

                    {activeField === "LIVING" && (
                      <p className="mt-1 text-[10px] text-gray-500 text-left">
                        {(formData.LIVING || "").length}/60
                      </p>
                    )}
                  </div>
                </div>

                <div className="grid h-full grid-cols-2 grid-rows-[auto_1fr] gap-4">
                  <div
                    className="col-span-2 h-[450px] border-2 border-gray-300 cursor-pointer overflow-hidden"
                    onClick={() => openFilePicker("page5_img1")}
                  >
                    {images.page5_img1 && (
                      <img
                        alt="img"
                        src={images.page5_img1}
                        className="w-full h-full object-cover"
                      />
                    )}
                    <div className="flex flex-col items-center justify-center h-full text-gray-500">
                      <svg
                        width="60"
                        height="60"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x="2"
                          y="4"
                          width="16"
                          height="13"
                          rx="2"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                        <path
                          d="M2 13L6 9L11 14L14 11L18 15"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle
                          cx="17"
                          cy="17"
                          r="6"
                          fill="white"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M17 14V20M14 17H20"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                      </svg>

                      <span className="mt-2">Add Only Webp img</span>
                    </div>

                    <input
                      type="file"
                      accept="image/webp"
                      ref={(el) => (fileInputRefs.current["page5_img1"] = el)}
                      onChange={(e) => handleImageUpload(e, "page5_img1")}
                      className="hidden"
                    />
                  </div>

                  <div className="flex flex-col gap-2">
                    <div
                      className="h-[230px] w-[430px] border-2 border-gray-300 cursor-pointer overflow-hidden"
                      onClick={() => openFilePicker("page5_img2")}
                    >
                      {images.page5_img2 && (
                        <img
                          alt="img"
                          src={images.page5_img2}
                          className="w-full h-full object-cover"
                        />
                      )}
                      <div className="flex flex-col items-center justify-center h-full text-gray-500">
                        <svg
                          width="60"
                          height="60"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <rect
                            x="2"
                            y="4"
                            width="16"
                            height="13"
                            rx="2"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                          <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                          <path
                            d="M2 13L6 9L11 14L14 11L18 15"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                          <circle
                            cx="17"
                            cy="17"
                            r="6"
                            fill="white"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                          <path
                            d="M17 14V20M14 17H20"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                        </svg>

                        <span className="mt-2">Add Only Webp img</span>
                      </div>

                      <input
                        type="file"
                        accept="image/webp"
                        ref={(el) => (fileInputRefs.current["page5_img2"] = el)}
                        onChange={(e) => handleImageUpload(e, "page5_img2")}
                        className="hidden"
                      />
                    </div>

                    <div
                      className="h-[230px] w-[430px] border-2 border-gray-300 cursor-pointer overflow-hidden"
                      onClick={() => openFilePicker("page5_img3")}
                    >
                      {images.page5_img3 && (
                        <img
                          alt="img"
                          src={images.page5_img3}
                          className="w-full h-full object-cover"
                        />
                      )}
                      <div className="flex flex-col items-center justify-center h-full text-gray-500">
                        <svg
                          width="60"
                          height="60"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <rect
                            x="2"
                            y="4"
                            width="16"
                            height="13"
                            rx="2"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                          <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                          <path
                            d="M2 13L6 9L11 14L14 11L18 15"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                          <circle
                            cx="17"
                            cy="17"
                            r="6"
                            fill="white"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                          <path
                            d="M17 14V20M14 17H20"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                        </svg>

                        <span className="mt-2">Add Only Webp img</span>
                      </div>

                      <input
                        type="file"
                        accept="image/webp"
                        ref={(el) => (fileInputRefs.current["page5_img3"] = el)}
                        onChange={(e) => handleImageUpload(e, "page5_img3")}
                        className="hidden"
                      />
                    </div>
                  </div>

                  <div
                    className="h-[350px] w-[230px] ml-24 border-2 border-gray-300 cursor-pointer overflow-hidden"
                    onClick={() => openFilePicker("page5_img4")}
                  >
                    {images.page5_img4 && (
                      <img
                        alt="img"
                        src={images.page5_img4}
                        className="w-full h-full object-cover"
                      />
                    )}
                    <div className="flex flex-col items-center justify-center h-full text-gray-500">
                      <svg
                        width="60"
                        height="60"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x="2"
                          y="4"
                          width="16"
                          height="13"
                          rx="2"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                        <path
                          d="M2 13L6 9L11 14L14 11L18 15"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle
                          cx="17"
                          cy="17"
                          r="6"
                          fill="white"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M17 14V20M14 17H20"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                      </svg>

                      <span className="mt-2">Add Only Webp img</span>
                    </div>

                    <input
                      type="file"
                      accept="image/webp"
                      ref={(el) => (fileInputRefs.current["page5_img4"] = el)}
                      onChange={(e) => handleImageUpload(e, "page5_img4")}
                      className="hidden"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* page 6 */}
            <div className="a4-container relative overflow-hidden bg-white print:shadow-none">
              <div className="flex h-full w-full flex-col p-16">
                <div className="mt-5 mb-3 flex justify-start">
                  <div className="w-full">
                    <input
                      type="text"
                      placeholder="KITCHEN & DINING"
                      value={formData.KITCHEN || ""}
                      onChange={(e) => handleChange("KITCHEN", e.target.value)}
                      onFocus={() => setActiveField("KITCHEN")}
                      onBlur={() => setActiveField(null)}
                      maxLength={60}
                      className="montserrat text-[10px] font-semibold uppercase tracking-[0.3em]
                    w-full py-2 pl-2 pr-4 text-left
                    bg-transparent border border-transparent duration-300
                    focus:border-black focus:ring-0 outline-none"
                    />

                    {activeField === "KITCHEN" && (
                      <p className="mt-1 text-[10px] text-gray-500 text-right">
                        {(formData.KITCHEN || "").length}/60
                      </p>
                    )}
                  </div>
                </div>

                <div className="flex flex-col h-full gap-4">
                  <div
                    className="w-full h-[450px] border-2 border-gray-300 cursor-pointer overflow-hidden"
                    onClick={() => openFilePicker("page6_img1")}
                  >
                    {images.page6_img1 && (
                      <img
                        alt="img"
                        src={images.page6_img1}
                        className="w-full h-full object-cover"
                      />
                    )}
                    <div className="flex flex-col items-center justify-center h-full text-gray-500">
                      <svg
                        width="60"
                        height="60"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x="2"
                          y="4"
                          width="16"
                          height="13"
                          rx="2"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                        <path
                          d="M2 13L6 9L11 14L14 11L18 15"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle
                          cx="17"
                          cy="17"
                          r="6"
                          fill="white"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M17 14V20M14 17H20"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                      </svg>

                      <span className="mt-2">Add Only Webp img</span>
                    </div>

                    <input
                      type="file"
                      accept="image/webp"
                      ref={(el) => (fileInputRefs.current["page6_img1"] = el)}
                      onChange={(e) => handleImageUpload(e, "page6_img1")}
                      className="hidden"
                    />
                  </div>

                  <div className="grid grid-cols-2 gap-4 h-[440px]">
                    <div
                      className="h-full w-full border-2 border-gray-300 cursor-pointer overflow-hidden"
                      onClick={() => openFilePicker("page6_img2")}
                    >
                      {images.page6_img2 && (
                        <img
                          alt="img"
                          src={images.page6_img2}
                          className="w-full h-full object-cover"
                        />
                      )}
                      <div className="flex flex-col items-center justify-center h-full text-gray-500">
                        <svg
                          width="60"
                          height="60"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <rect
                            x="2"
                            y="4"
                            width="16"
                            height="13"
                            rx="2"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                          <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                          <path
                            d="M2 13L6 9L11 14L14 11L18 15"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                          <circle
                            cx="17"
                            cy="17"
                            r="6"
                            fill="white"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                          <path
                            d="M17 14V20M14 17H20"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                        </svg>

                        <span className="mt-2">Add Only Webp img</span>
                      </div>

                      <input
                        type="file"
                        accept="image/webp"
                        ref={(el) => (fileInputRefs.current["page6_img2"] = el)}
                        onChange={(e) => handleImageUpload(e, "page6_img2")}
                        className="hidden"
                      />
                    </div>
                    <div
                      className="h-full w-full border-2 border-gray-300 cursor-pointer overflow-hidden"
                      onClick={() => openFilePicker("page6_img3")}
                    >
                      {images.page6_img3 && (
                        <img
                          alt="img"
                          src={images.page6_img3}
                          className="w-full h-full object-cover"
                        />
                      )}
                      <div className="flex flex-col items-center justify-center h-full text-gray-500">
                        <svg
                          width="60"
                          height="60"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <rect
                            x="2"
                            y="4"
                            width="16"
                            height="13"
                            rx="2"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                          <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                          <path
                            d="M2 13L6 9L11 14L14 11L18 15"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                          <circle
                            cx="17"
                            cy="17"
                            r="6"
                            fill="white"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                          <path
                            d="M17 14V20M14 17H20"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                        </svg>

                        <span className="mt-2">Add Only Webp img</span>
                      </div>

                      <input
                        type="file"
                        accept="image/webp"
                        ref={(el) => (fileInputRefs.current["page6_img3"] = el)}
                        onChange={(e) => handleImageUpload(e, "page6_img3")}
                        className="hidden"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* page 7 */}
            <div className="a4-container relative overflow-hidden bg-white print:shadow-none">
              <div className="h-full w-full flex flex-col p-0">
                <div
                  className="flex-1 w-full overflow-hidden cursor-pointer"
                  onClick={() => openFilePicker("page7_img1")}
                >
                  {images.page7_img1 && (
                    <img
                      alt="img"
                      src={images.page7_img1}
                      className="w-full h-full object-cover"
                    />
                  )}
                  <div className="flex flex-col items-center justify-center h-full text-gray-500">
                    <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
                      <rect
                        x="2"
                        y="4"
                        width="16"
                        height="13"
                        rx="2"
                        stroke="black"
                        strokeWidth="1.5"
                      />
                      <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                      <path
                        d="M2 13L6 9L11 14L14 11L18 15"
                        stroke="black"
                        strokeWidth="1.5"
                      />
                      <circle
                        cx="17"
                        cy="17"
                        r="6"
                        fill="white"
                        stroke="black"
                        strokeWidth="1.5"
                      />
                      <path
                        d="M17 14V20M14 17H20"
                        stroke="black"
                        strokeWidth="1.5"
                      />
                    </svg>

                    <span className="mt-2">Add Only Webp img</span>
                  </div>

                  <input
                    type="file"
                    accept="image/webp"
                    ref={(el) => (fileInputRefs.current["page7_img1"] = el)}
                    onChange={(e) => handleImageUpload(e, "page7_img1")}
                    className="hidden"
                  />
                </div>
              </div>
            </div>

            {/* page 8 */}
            <div className="a4-container relative overflow-hidden bg-white print:shadow-none">
              <div className="flex h-full w-full flex-col p-16">
                <div className="mt-5 mb-3 flex justify-start">
                  <div className="w-full">
                    <input
                      type="text"
                      placeholder="ROOMS & BATHS"
                      value={formData.ROOMS || ""}
                      onChange={(e) => handleChange("ROOMS", e.target.value)}
                      onFocus={() => setActiveField("ROOMS")}
                      onBlur={() => setActiveField(null)}
                      maxLength={60}
                      className="montserrat text-[10px] font-semibold uppercase tracking-[0.3em]
                    w-full py-2 pl-2 pr-4 text-left
                    bg-transparent border border-transparent duration-300
                    focus:border-black focus:ring-0 outline-none"
                    />

                    {activeField === "ROOMS" && (
                      <p className="mt-1 text-[10px] text-gray-500 text-right">
                        {(formData.ROOMS || "").length}/60
                      </p>
                    )}
                  </div>
                </div>

                <div className="flex flex-col h-full gap-4">
                  <div
                    className="w-full h-[450px] border-2 border-gray-300 cursor-pointer overflow-hidden"
                    onClick={() => openFilePicker("page8_img1")}
                  >
                    {images.page8_img1 && (
                      <img
                        alt="img"
                        src={images.page8_img1}
                        className="w-full h-full object-cover"
                      />
                    )}
                    <div className="flex flex-col items-center justify-center h-full text-gray-500">
                      <svg
                        width="60"
                        height="60"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x="2"
                          y="4"
                          width="16"
                          height="13"
                          rx="2"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                        <path
                          d="M2 13L6 9L11 14L14 11L18 15"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle
                          cx="17"
                          cy="17"
                          r="6"
                          fill="white"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M17 14V20M14 17H20"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                      </svg>

                      <span className="mt-2">Add Only Webp img</span>
                    </div>

                    <input
                      type="file"
                      accept="image/webp"
                      ref={(el) => (fileInputRefs.current["page8_img1"] = el)}
                      onChange={(e) => handleImageUpload(e, "page8_img1")}
                      className="hidden"
                    />
                  </div>

                  <div
                    className="w-full h-[440px] border-2 border-gray-300 cursor-pointer overflow-hidden"
                    onClick={() => openFilePicker("page8_img2")}
                  >
                    {images.page8_img2 && (
                      <img
                        alt="img"
                        src={images.page8_img2}
                        className="w-full h-full object-cover"
                      />
                    )}
                    <div className="flex flex-col items-center justify-center h-full text-gray-500">
                      <svg
                        width="60"
                        height="60"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x="2"
                          y="4"
                          width="16"
                          height="13"
                          rx="2"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                        <path
                          d="M2 13L6 9L11 14L14 11L18 15"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle
                          cx="17"
                          cy="17"
                          r="6"
                          fill="white"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M17 14V20M14 17H20"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                      </svg>

                      <span className="mt-2">Add Only Webp img</span>
                    </div>

                    <input
                      type="file"
                      accept="image/webp"
                      ref={(el) => (fileInputRefs.current["page8_img2"] = el)}
                      onChange={(e) => handleImageUpload(e, "page8_img2")}
                      className="hidden"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* page 9 */}
            <div className="a4-container relative overflow-hidden bg-white print:shadow-none">
              <div className="flex h-full w-full flex-col p-16">
                <div className="flex flex-col h-full gap-8 mt-10">
                  <div
                    className="w-full h-[450px] border-2 border-gray-300 cursor-pointer overflow-hidden"
                    onClick={() => openFilePicker("page9_img1")}
                  >
                    {images.page9_img1 && (
                      <img
                        alt="img"
                        src={images.page9_img1}
                        className="w-full h-full object-cover"
                      />
                    )}
                    <div className="flex flex-col items-center justify-center h-full text-gray-500">
                      <svg
                        width="60"
                        height="60"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x="2"
                          y="4"
                          width="16"
                          height="13"
                          rx="2"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                        <path
                          d="M2 13L6 9L11 14L14 11L18 15"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle
                          cx="17"
                          cy="17"
                          r="6"
                          fill="white"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M17 14V20M14 17H20"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                      </svg>

                      <span className="mt-2">Add Only Webp img</span>
                    </div>

                    <input
                      type="file"
                      accept="image/webp"
                      ref={(el) => (fileInputRefs.current["page9_img1"] = el)}
                      onChange={(e) => handleImageUpload(e, "page9_img1")}
                      className="hidden"
                    />
                  </div>

                  <div className="flex justify-end w-full">
                    <div
                      className="w-[75%] h-[400px] border-2 border-gray-300 cursor-pointer overflow-hidden"
                      onClick={() => openFilePicker("page9_img2")}
                    >
                      {images.page9_img2 && (
                        <img
                          alt="img"
                          src={images.page9_img2}
                          className="w-full h-full object-cover"
                        />
                      )}
                      <div className="flex flex-col items-center justify-center h-full text-gray-500">
                        <svg
                          width="60"
                          height="60"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <rect
                            x="2"
                            y="4"
                            width="16"
                            height="13"
                            rx="2"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                          <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                          <path
                            d="M2 13L6 9L11 14L14 11L18 15"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                          <circle
                            cx="17"
                            cy="17"
                            r="6"
                            fill="white"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                          <path
                            d="M17 14V20M14 17H20"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                        </svg>

                        <span className="mt-2">Add Only Webp img</span>
                      </div>

                      <input
                        type="file"
                        accept="image/webp"
                        ref={(el) => (fileInputRefs.current["page9_img2"] = el)}
                        onChange={(e) => handleImageUpload(e, "page9_img2")}
                        className="hidden"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* page 10 */}
            <div className="a4-container relative overflow-hidden bg-white print:shadow-none">
              <div className="flex h-full w-full flex-col p-16">
                <div className="flex flex-col h-full gap-4 mt-10">
                  <div
                    className="w-full h-[450px] border-2 border-gray-300 cursor-pointer overflow-hidden"
                    onClick={() => openFilePicker("page10_img1")}
                  >
                    {images.page10_img1 && (
                      <img
                        alt="img"
                        src={images.page10_img1}
                        className="w-full h-full object-cover"
                      />
                    )}
                    <div className="flex flex-col items-center justify-center h-full text-gray-500">
                      <svg
                        width="60"
                        height="60"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x="2"
                          y="4"
                          width="16"
                          height="13"
                          rx="2"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                        <path
                          d="M2 13L6 9L11 14L14 11L18 15"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle
                          cx="17"
                          cy="17"
                          r="6"
                          fill="white"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M17 14V20M14 17H20"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                      </svg>

                      <span className="mt-2">Add Only Webp img</span>
                    </div>

                    <input
                      type="file"
                      accept="image/webp"
                      ref={(el) => (fileInputRefs.current["page10_img1"] = el)}
                      onChange={(e) => handleImageUpload(e, "page10_img1")}
                      className="hidden"
                    />
                  </div>

                  <div className="flex gap-4 h-[440px]">
                    <div
                      className="w-[40%] h-full border-2 border-gray-300 cursor-pointer overflow-hidden"
                      onClick={() => openFilePicker("page10_img2")}
                    >
                      {images.page10_img2 && (
                        <img
                          alt="img"
                          src={images.page10_img2}
                          className="w-full h-full object-cover"
                        />
                      )}
                      <div className="flex flex-col items-center justify-center h-full text-gray-500">
                        <svg
                          width="60"
                          height="60"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <rect
                            x="2"
                            y="4"
                            width="16"
                            height="13"
                            rx="2"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                          <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                          <path
                            d="M2 13L6 9L11 14L14 11L18 15"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                          <circle
                            cx="17"
                            cy="17"
                            r="6"
                            fill="white"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                          <path
                            d="M17 14V20M14 17H20"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                        </svg>

                        <span className="mt-2">Add Only Webp img</span>
                      </div>

                      <input
                        type="file"
                        accept="image/webp"
                        ref={(el) =>
                          (fileInputRefs.current["page10_img2"] = el)
                        }
                        onChange={(e) => handleImageUpload(e, "page10_img2")}
                        className="hidden"
                      />
                    </div>

                    <div className="w-[60%] h-full flex items-start">
                      <div
                        className="w-full h-[60%] border-2 border-gray-300 cursor-pointer overflow-hidden"
                        onClick={() => openFilePicker("page10_img3")}
                      >
                        {images.page10_img3 && (
                          <img
                            alt="img"
                            src={images.page10_img3}
                            className="w-full h-full object-cover"
                          />
                        )}
                        <div className="flex flex-col items-center justify-center h-full text-gray-500">
                          <svg
                            width="60"
                            height="60"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <rect
                              x="2"
                              y="4"
                              width="16"
                              height="13"
                              rx="2"
                              stroke="black"
                              strokeWidth="1.5"
                            />
                            <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                            <path
                              d="M2 13L6 9L11 14L14 11L18 15"
                              stroke="black"
                              strokeWidth="1.5"
                            />
                            <circle
                              cx="17"
                              cy="17"
                              r="6"
                              fill="white"
                              stroke="black"
                              strokeWidth="1.5"
                            />
                            <path
                              d="M17 14V20M14 17H20"
                              stroke="black"
                              strokeWidth="1.5"
                            />
                          </svg>

                          <span className="mt-2">Add Only Webp img</span>
                        </div>

                        <input
                          type="file"
                          accept="image/webp"
                          ref={(el) =>
                            (fileInputRefs.current["page10_img3"] = el)
                          }
                          onChange={(e) => handleImageUpload(e, "page10_img3")}
                          className="hidden"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* page 11 */}
            <div className="a4-container relative overflow-hidden bg-white print:shadow-none">
              <div className="flex h-full w-full flex-col p-16">
                <div className="flex flex-col h-full gap-4 mt-10">
                  <div
                    className="w-full h-[450px] border-2 border-gray-300 cursor-pointer overflow-hidden"
                    onClick={() => openFilePicker("page11_img1")}
                  >
                    {images.page11_img1 && (
                      <img
                        alt="img"
                        src={images.page11_img1}
                        className="w-full h-full object-cover"
                      />
                    )}
                    <div className="flex flex-col items-center justify-center h-full text-gray-500">
                      <svg
                        width="60"
                        height="60"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x="2"
                          y="4"
                          width="16"
                          height="13"
                          rx="2"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                        <path
                          d="M2 13L6 9L11 14L14 11L18 15"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle
                          cx="17"
                          cy="17"
                          r="6"
                          fill="white"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M17 14V20M14 17H20"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                      </svg>

                      <span className="mt-2">Add Only Webp img</span>
                    </div>

                    <input
                      type="file"
                      accept="image/webp"
                      ref={(el) => (fileInputRefs.current["page11_img1"] = el)}
                      onChange={(e) => handleImageUpload(e, "page11_img1")}
                      className="hidden"
                    />
                  </div>

                  <div
                    className="w-full h-[440px] border-2 border-gray-300 cursor-pointer overflow-hidden"
                    onClick={() => openFilePicker("page11_img2")}
                  >
                    {images.page11_img2 && (
                      <img
                        alt="img"
                        src={images.page11_img2}
                        className="w-full h-full object-cover"
                      />
                    )}
                    <div className="flex flex-col items-center justify-center h-full text-gray-500">
                      <svg
                        width="60"
                        height="60"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x="2"
                          y="4"
                          width="16"
                          height="13"
                          rx="2"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                        <path
                          d="M2 13L6 9L11 14L14 11L18 15"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle
                          cx="17"
                          cy="17"
                          r="6"
                          fill="white"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M17 14V20M14 17H20"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                      </svg>

                      <span className="mt-2">Add Only Webp img</span>
                    </div>

                    <input
                      type="file"
                      accept="image/webp"
                      ref={(el) => (fileInputRefs.current["page11_img2"] = el)}
                      onChange={(e) => handleImageUpload(e, "page11_img2")}
                      className="hidden"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* page 12 */}
            <div className="a4-container relative overflow-hidden bg-white print:shadow-none">
              <div className="flex h-full w-full flex-col p-16">
                <div className="flex flex-col h-full gap-4 mt-10">
                  <div
                    className="w-full h-[450px] border-2 border-gray-300 cursor-pointer overflow-hidden"
                    onClick={() => openFilePicker("page12_img1")}
                  >
                    {images.page12_img1 && (
                      <img
                        alt="img"
                        src={images.page12_img1}
                        className="w-full h-full object-cover"
                      />
                    )}
                    <div className="flex flex-col items-center justify-center h-full text-gray-500">
                      <svg
                        width="60"
                        height="60"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x="2"
                          y="4"
                          width="16"
                          height="13"
                          rx="2"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                        <path
                          d="M2 13L6 9L11 14L14 11L18 15"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle
                          cx="17"
                          cy="17"
                          r="6"
                          fill="white"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M17 14V20M14 17H20"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                      </svg>

                      <span className="mt-2">Add Only Webp img</span>
                    </div>

                    <input
                      type="file"
                      accept="image/webp"
                      ref={(el) => (fileInputRefs.current["page12_img1"] = el)}
                      onChange={(e) => handleImageUpload(e, "page12_img1")}
                      className="hidden"
                    />
                  </div>

                  <div
                    className="w-full h-[440px] border-2 border-gray-300 cursor-pointer overflow-hidden"
                    onClick={() => openFilePicker("page12_img2")}
                  >
                    {images.page12_img2 && (
                      <img
                        alt="img"
                        src={images.page12_img2}
                        className="w-full h-full object-cover"
                      />
                    )}
                    <div className="flex flex-col items-center justify-center h-full text-gray-500">
                      <svg
                        width="60"
                        height="60"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x="2"
                          y="4"
                          width="16"
                          height="13"
                          rx="2"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                        <path
                          d="M2 13L6 9L11 14L14 11L18 15"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle
                          cx="17"
                          cy="17"
                          r="6"
                          fill="white"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M17 14V20M14 17H20"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                      </svg>

                      <span className="mt-2">Add Only Webp img</span>
                    </div>

                    <input
                      type="file"
                      accept="image/webp"
                      ref={(el) => (fileInputRefs.current["page12_img2"] = el)}
                      onChange={(e) => handleImageUpload(e, "page12_img2")}
                      className="hidden"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* page 13 */}
            <div className="a4-container relative overflow-hidden bg-white print:shadow-none">
              <div className="flex h-full w-full flex-col p-16">
                <div className="mb-3 flex justify-start">
                  <div className="w-full">
                    <input
                      type="text"
                      placeholder="COMMON AREA"
                      value={formData.COMMON || ""}
                      onChange={(e) => handleChange("COMMON", e.target.value)}
                      onFocus={() => setActiveField("COMMON")}
                      onBlur={() => setActiveField(null)}
                      maxLength={60}
                      className="montserrat text-[10px] font-semibold uppercase tracking-[0.3em]
                    w-full py-2 pl-2 pr-4 text-left
                    bg-transparent border border-transparent duration-300
                    focus:border-black focus:ring-0 outline-none"
                    />

                    {activeField === "COMMON" && (
                      <p className="mt-1 text-[10px] text-gray-500 text-right">
                        {(formData.COMMON || "").length}/60
                      </p>
                    )}
                  </div>
                </div>

                <div className="flex flex-col h-full gap-6">
                  <div
                    className="w-full h-[550px] border-2 border-gray-300 cursor-pointer overflow-hidden"
                    onClick={() => openFilePicker("page13_img1")}
                  >
                    {images.page13_img1 && (
                      <img
                        alt="img"
                        src={images.page13_img1}
                        className="w-full h-full object-cover"
                      />
                    )}
                    <div className="flex flex-col items-center justify-center h-full text-gray-500">
                      <svg
                        width="60"
                        height="60"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x="2"
                          y="4"
                          width="16"
                          height="13"
                          rx="2"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                        <path
                          d="M2 13L6 9L11 14L14 11L18 15"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle
                          cx="17"
                          cy="17"
                          r="6"
                          fill="white"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M17 14V20M14 17H20"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                      </svg>

                      <span className="mt-2">Add Only Webp img</span>
                    </div>

                    <input
                      type="file"
                      accept="image/webp"
                      ref={(el) => (fileInputRefs.current["page13_img1"] = el)}
                      onChange={(e) => handleImageUpload(e, "page13_img1")}
                      className="hidden"
                    />
                  </div>

                  <div
                    className="w-[350px] h-[320px] border-2 border-gray-300 cursor-pointer overflow-hidden"
                    onClick={() => openFilePicker("page13_img2")}
                  >
                    {images.page13_img2 && (
                      <img
                        alt="img"
                        src={images.page13_img2}
                        className="w-full h-full object-cover"
                      />
                    )}
                    <div className="flex flex-col items-center justify-center h-full text-gray-500">
                      <svg
                        width="60"
                        height="60"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x="2"
                          y="4"
                          width="16"
                          height="13"
                          rx="2"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                        <path
                          d="M2 13L6 9L11 14L14 11L18 15"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle
                          cx="17"
                          cy="17"
                          r="6"
                          fill="white"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M17 14V20M14 17H20"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                      </svg>

                      <span className="mt-2">Add Only Webp img</span>
                    </div>

                    <input
                      type="file"
                      accept="image/webp"
                      ref={(el) => (fileInputRefs.current["page13_img2"] = el)}
                      onChange={(e) => handleImageUpload(e, "page13_img2")}
                      className="hidden"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* page 14 */}
            <div className="a4-container relative overflow-hidden bg-white print:shadow-none">
              <div className="flex h-full w-full flex-col p-16">
                <div className="flex flex-col h-full gap-4 mt-10">
                  <div
                    className="w-full h-[450px] border-2 border-gray-300 cursor-pointer overflow-hidden"
                    onClick={() => openFilePicker("page14_img1")}
                  >
                    {images.page14_img1 && (
                      <img
                        alt="img"
                        src={images.page14_img1}
                        className="w-full h-full object-cover"
                      />
                    )}
                    <div className="flex flex-col items-center justify-center h-full text-gray-500">
                      <svg
                        width="60"
                        height="60"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x="2"
                          y="4"
                          width="16"
                          height="13"
                          rx="2"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                        <path
                          d="M2 13L6 9L11 14L14 11L18 15"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle
                          cx="17"
                          cy="17"
                          r="6"
                          fill="white"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M17 14V20M14 17H20"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                      </svg>

                      <span className="mt-2">Add Only Webp img</span>
                    </div>

                    <input
                      type="file"
                      accept="image/webp"
                      ref={(el) => (fileInputRefs.current["page14_img1"] = el)}
                      onChange={(e) => handleImageUpload(e, "page14_img1")}
                      className="hidden"
                    />
                  </div>

                  <div
                    className="w-full h-[440px] border-2 border-gray-300 cursor-pointer overflow-hidden"
                    onClick={() => openFilePicker("page14_img2")}
                  >
                    {images.page14_img2 && (
                      <img
                        alt="img"
                        src={images.page14_img2}
                        className="w-full h-full object-cover"
                      />
                    )}
                    <div className="flex flex-col items-center justify-center h-full text-gray-500">
                      <svg
                        width="60"
                        height="60"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x="2"
                          y="4"
                          width="16"
                          height="13"
                          rx="2"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                        <path
                          d="M2 13L6 9L11 14L14 11L18 15"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle
                          cx="17"
                          cy="17"
                          r="6"
                          fill="white"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M17 14V20M14 17H20"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                      </svg>

                      <span className="mt-2">Add Only Webp img</span>
                    </div>

                    <input
                      type="file"
                      accept="image/webp"
                      ref={(el) => (fileInputRefs.current["page14_img2"] = el)}
                      onChange={(e) => handleImageUpload(e, "page14_img2")}
                      className="hidden"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* page 15 */}
            <div className="a4-container relative overflow-hidden bg-white print:shadow-none">
              <div className="flex h-full w-full flex-col p-16">
                <div className="flex flex-col h-full gap-4 mt-10">
                  <div
                    className="w-full h-[450px] border-2 border-gray-300 cursor-pointer overflow-hidden"
                    onClick={() => openFilePicker("page15_img1")}
                  >
                    {images.page15_img1 && (
                      <img
                        alt="img"
                        src={images.page15_img1}
                        className="w-full h-full object-cover"
                      />
                    )}
                    <div className="flex flex-col items-center justify-center h-full text-gray-500">
                      <svg
                        width="60"
                        height="60"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x="2"
                          y="4"
                          width="16"
                          height="13"
                          rx="2"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                        <path
                          d="M2 13L6 9L11 14L14 11L18 15"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle
                          cx="17"
                          cy="17"
                          r="6"
                          fill="white"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M17 14V20M14 17H20"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                      </svg>

                      <span className="mt-2">Add Only Webp img</span>
                    </div>

                    <input
                      type="file"
                      accept="image/webp"
                      ref={(el) => (fileInputRefs.current["page15_img1"] = el)}
                      onChange={(e) => handleImageUpload(e, "page15_img1")}
                      className="hidden"
                    />
                  </div>

                  <div
                    className="w-full h-[440px] border-2 border-gray-300 cursor-pointer overflow-hidden"
                    onClick={() => openFilePicker("page15_img2")}
                  >
                    {images.page15_img2 && (
                      <img
                        alt="img"
                        src={images.page15_img2}
                        className="w-full h-full object-cover"
                      />
                    )}
                    <div className="flex flex-col items-center justify-center h-full text-gray-500">
                      <svg
                        width="60"
                        height="60"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x="2"
                          y="4"
                          width="16"
                          height="13"
                          rx="2"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle cx="6.5" cy="8.5" r="1.5" fill="black" />
                        <path
                          d="M2 13L6 9L11 14L14 11L18 15"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <circle
                          cx="17"
                          cy="17"
                          r="6"
                          fill="white"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M17 14V20M14 17H20"
                          stroke="black"
                          strokeWidth="1.5"
                        />
                      </svg>

                      <span className="mt-2">Add Only Webp img</span>
                    </div>

                    <input
                      type="file"
                      accept="image/webp"
                      ref={(el) => (fileInputRefs.current["page15_img2"] = el)}
                      onChange={(e) => handleImageUpload(e, "page15_img2")}
                      className="hidden"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* page 16 */}
            <div className="a4-container relative overflow-hidden bg-white print:shadow-none">
              <div className="flex h-full w-full flex-col px-20 pt-24">
                <div className="mb-40">
                  <h2 className="text-4xl playfair">About Zorba</h2>
                </div>

                <div className="flex justify-end w-full">
                  <div className="max-w-sm">
                    <input
                      type="text"
                      placeholder="Find your self in nature."
                      value={formData.About}
                      onChange={(e) => handleChange("About", e.target.value)}
                      onFocus={() => setActiveField("About")}
                      onBlur={() => setActiveField(null)}
                      maxLength={30}
                      className="italic playfair text-2xl w-full
                    bg-transparent border border-transparent 
                    focus:border-black outline-none duration-300 focus:ring-0"
                    />

                    {activeField === "About" && (
                      <p className="text-xs text-gray-500">
                        {(formData.About || "").length}/30
                      </p>
                    )}

                    <textarea
                      value={formData.aboutPara1 || ""}
                      placeholder="start..."
                      onChange={(e) =>
                        handleChange("aboutPara1", e.target.value)
                      }
                      onFocus={() => setActiveField("aboutPara1")}
                      onBlur={() => setActiveField(null)}
                      maxLength={300}
                      rows={8}
                      className="montserrat text-[15px] leading-relaxed mt-6 text-justify w-full
                      bg-transparent border border-transparent p-2
                      focus:border-black outline-none resize-none"
                    />

                    {activeField === "aboutPara1" && (
                      <p className="text-xs text-gray-500">
                        {(formData.aboutPara1 || "").length}/300
                      </p>
                    )}

                    <textarea
                      value={formData.aboutPara2 || ""}
                      placeholder="start..."
                      onChange={(e) =>
                        handleChange("aboutPara2", e.target.value)
                      }
                      onFocus={() => setActiveField("aboutPara2")}
                      onBlur={() => setActiveField(null)}
                      maxLength={200}
                      rows={6}
                      className="montserrat text-[15px] leading-relaxed mt-6 text-justify w-full
                    bg-transparent border border-transparent p-2
                    focus:border-black outline-none resize-none"
                    />

                    {activeField === "aboutPara2" && (
                      <p className="text-xs text-gray-500">
                        {(formData.aboutPara2 || "").length}/200
                      </p>
                    )}

                    <textarea
                      value={formData.aboutPara3 || ""}
                      placeholder="start..."
                      onChange={(e) =>
                        handleChange("aboutPara3", e.target.value)
                      }
                      onFocus={() => setActiveField("aboutPara3")}
                      onBlur={() => setActiveField(null)}
                      maxLength={350}
                      rows={8}
                      className="montserrat text-[15px] leading-relaxed mt-6 text-justify w-full
                      bg-transparent border border-transparent p-2
                      focus:border-black outline-none resize-none"
                    />

                    {activeField === "aboutPara3" && (
                      <p className="text-xs text-gray-500">
                        {(formData.aboutPara3 || "").length}/350
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* page 17 */}
            <div className="a4-container relative overflow-hidden bg-white print:shadow-none">
              <div className="flex h-full w-full flex-col items-center justify-center relative px-16">
                <div className="flex flex-col items-center justify-center">
                  <img
                    src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d4289f22-91de-411f-d677-6e92f843ea00/public"
                    alt="Zorba Logo"
                    className="w-[40%] brightness-0"
                  />
                </div>

                <div className="absolute bottom-6 w-full text-center">
                  <p className="montserrat text-[10px] tracking-[0.2em]">
                    <a
                      href="https://zorbastays.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span>www.zorbastays.com</span>
                    </a>{" "}
                    |{" "}
                    <a href="mailto:info@zorbastays.com">
                      <span>info@zorbastays.com</span>
                    </a>{" "}
                    | <span>63552-31066, 98750-28066</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default HotelBrochureElementor;
